import { CONSIGNMENT_ITEM_KEY } from '../consignment-item/keys'

// eslint-disable-next-line import/prefer-default-export
export const consignmentItemDocumentQueryKeys = {
  byConsignmentItemId: (consignmentItemId: number | null) => [CONSIGNMENT_ITEM_KEY, consignmentItemId, 'documents'],
}
